import { UserDto } from '@admin/app/api'
import { UserStore } from '@admin/stores/user.store'
import { action, computed, makeObservable, observable } from 'mobx'

export class UserUIStore {
  toBeRemoveUserId?: string

  constructor(public store: UserStore) {
    makeObservable(this, {
      toBeRemoveUserId: observable,

      users: computed,

      setToBeRemoveUserId: action,
    })
  }

  get users() {
    return [...this.store.data].sort((a, b) => (a.email ?? '').localeCompare(b.email ?? ''))
  }

  isUnique(dto: UserDto) {
    return (
      this.store.data.filter(
        e => dto.email.toUpperCase() == e.email.toUpperCase() && dto.user_id != e.user_id,
      ).length == 0
    )
  }

  public setToBeRemoveUserId(toBeRemoveUserId?: string) {
    this.toBeRemoveUserId = toBeRemoveUserId
  }
}
